'use strict';

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-abstract/helpers/isNaN.js
// module id = 2703
// module chunks = 0